/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import ListChatActivityAssignees_Embed_refetchable from "./ListChatActivityAssignees_Embed_refetchable.graphql";
import { FragmentRefs } from "relay-runtime";
export type ListChatActivityAssignees_EmbedQuery = {
    readonly viewer: {
        readonly _id: string;
        readonly " $fragmentRefs": FragmentRefs<"ListItemAssignee_EmbedNode">;
    } | null;
    readonly userMany: ReadonlyArray<{
        readonly _id: string;
        readonly " $fragmentRefs": FragmentRefs<"ListItemAssignee_EmbedNode">;
    } | null> | null;
    readonly groupMany: ReadonlyArray<{
        readonly _id: string;
        readonly " $fragmentRefs": FragmentRefs<"ListItemAssignee_EmbedNode">;
    } | null> | null;
    readonly providerConnection: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly _id: string;
                readonly " $fragmentRefs": FragmentRefs<"ListItemAssignee_EmbedNode">;
            };
        }>;
    } | null;
    readonly " $refType": "ListChatActivityAssignees_EmbedQuery";
};
export type ListChatActivityAssignees_EmbedQuery$data = ListChatActivityAssignees_EmbedQuery;
export type ListChatActivityAssignees_EmbedQuery$key = {
    readonly " $data"?: ListChatActivityAssignees_EmbedQuery$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"ListChatActivityAssignees_EmbedQuery">;
};



const node: ReaderFragment = (function(){
var v0 = [
  "providerConnection"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "_id",
  "storageKey": null
},
v2 = {
  "kind": "Variable",
  "name": "filterChatActivityCount",
  "variableName": "filterChatActivityCount"
},
v3 = {
  "kind": "Variable",
  "name": "includeAvatar",
  "variableName": "includeAvatar"
},
v4 = {
  "kind": "Variable",
  "name": "includeChatActivityCount",
  "variableName": "includeChatActivityCount"
},
v5 = {
  "args": [
    (v2/*: any*/),
    (v3/*: any*/),
    (v4/*: any*/),
    {
      "kind": "Variable",
      "name": "includeEmail",
      "variableName": "includeEmail"
    }
  ],
  "kind": "FragmentSpread",
  "name": "ListItemAssignee_EmbedNode"
},
v6 = [
  (v1/*: any*/),
  (v5/*: any*/)
],
v7 = {
  "fields": [
    {
      "kind": "Variable",
      "name": "regex",
      "variableName": "regex"
    }
  ],
  "kind": "ObjectValue",
  "name": "name"
},
v8 = {
  "kind": "Literal",
  "name": "active",
  "value": 1
},
v9 = {
  "kind": "Literal",
  "name": "sort",
  "value": "NAME_ASC"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": 15,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "filterChatActivityCount"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeAvatar"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeChatActivityCount"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeEmail"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "regex"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": ListChatActivityAssignees_Embed_refetchable
    }
  },
  "name": "ListChatActivityAssignees_EmbedQuery",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "viewer",
      "plural": false,
      "selections": (v6/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "fields": [
            {
              "fields": [
                (v7/*: any*/),
                {
                  "kind": "Literal",
                  "name": "roles",
                  "value": {
                    "ne": "widget"
                  }
                }
              ],
              "kind": "ObjectValue",
              "name": "_operators"
            },
            (v8/*: any*/),
            {
              "kind": "Literal",
              "name": "type",
              "value": "staff"
            }
          ],
          "kind": "ObjectValue",
          "name": "filter"
        },
        (v9/*: any*/)
      ],
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "userMany",
      "plural": true,
      "selections": (v6/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "fields": [
            {
              "fields": [
                (v7/*: any*/),
                {
                  "kind": "Literal",
                  "name": "type",
                  "value": {
                    "ne": "system"
                  }
                }
              ],
              "kind": "ObjectValue",
              "name": "_operators"
            }
          ],
          "kind": "ObjectValue",
          "name": "filter"
        },
        (v9/*: any*/)
      ],
      "concreteType": "Group",
      "kind": "LinkedField",
      "name": "groupMany",
      "plural": true,
      "selections": [
        (v1/*: any*/),
        {
          "args": [
            (v2/*: any*/),
            (v3/*: any*/),
            (v4/*: any*/)
          ],
          "kind": "FragmentSpread",
          "name": "ListItemAssignee_EmbedNode"
        }
      ],
      "storageKey": null
    },
    {
      "alias": "providerConnection",
      "args": [
        {
          "fields": [
            {
              "fields": [
                (v7/*: any*/)
              ],
              "kind": "ObjectValue",
              "name": "_operators"
            },
            (v8/*: any*/),
            {
              "kind": "Literal",
              "name": "isRenderingProvider",
              "value": true
            },
            {
              "kind": "Literal",
              "name": "visible",
              "value": true
            }
          ],
          "kind": "ObjectValue",
          "name": "filter"
        },
        (v9/*: any*/)
      ],
      "concreteType": "ProviderConnection",
      "kind": "LinkedField",
      "name": "__ListChatActivityAssignees_providerConnection_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProviderEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Provider",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                (v5/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();
(node as any).hash = '0007374706e2578497b2c8eeb7fc0d03';
export default node;
